var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"create-wrapper"},[_c('div',{staticClass:"tabs"},[_c('h2',[_vm._v(_vm._s(_vm.$t('admin.create.createBlog')))])]),_c('keep-alive',[_c(_vm.getActiveComponent,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }